import { FeatureRequest, FeaturesRequest } from '../api/requests';
import type { UserStore } from '~/authentication/stores/user';
import type ApiClient from '~/common/services/ApiClient';

export class FeatureService {
  apiClient: ApiClient;
  userStore: UserStore;

  constructor(apiClient: ApiClient, userStore: UserStore) {
    this.apiClient = apiClient;
    this.userStore = userStore;
  }

  async get(featureId: string, params?: { include: string }) {
    const accessToken = this.userStore.accessToken;
    const request = new FeatureRequest({
      token: accessToken,
      featureId,
      params: { ...params },
    });

    return this.apiClient.request(request);
  }

  async fetch(params?: { include: string }) {
    const accessToken = this.userStore.accessToken;
    const request = new FeaturesRequest({
      token: accessToken,
      params: { ...params },
    });

    return this.apiClient.request(request);
  }
}
